import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import * as productionService from '../../../../services/productionService';
import * as imageService from '../../../../services/imageService';
import * as categoryService from '../../../../services/categoryService';
import classes from './Movie.scss';

class Movie extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    lang: PropTypes.string
  };
  static defaultProps = { lang: 'eng' };

  state = {
    loading: true,
    error: null,
    movie: null,
    image: null,
    category: null
  };

  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.movieKey !== this.props.match.params.movieKey) {
      this.load();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getRouteKey = () =>
    this.props.match?.params?.movieKey
    || this.props.match?.params?.id
    || this.props.match?.params?.key
    || null;

  async load() {
    const movieKey = this.getRouteKey();
    console.log('Movie route param:', movieKey, 'params:', this.props.match?.params);
    if (!movieKey) {
      this._isMounted && this.setState({ loading: false, error: new Error('No movie key in URL') });
      return;
    }
    this._isMounted && this.setState({ loading: true, error: null });

    try {
      const movie = await productionService.fetchMovie(movieKey);
      console.log('Movie fetch response:', movie);
      if (!movie) throw new Error('Movie not found: ' + movieKey);

      const [image, category] = await Promise.all([
        movie.image ? imageService.fetchImage(movie.image) : null,
        movie.category ? categoryService.fetchCategory(movie.category, this.props.lang, 'singular') : null
      ]);

      if (this._isMounted) this.setState({ movie, image, category, loading: false });
    } catch (err) {
      console.error('Movie load failed:', err);
      if (this._isMounted) this.setState({ error: err, loading: false });
    }
  }

  render() {
    const movieKey = this.getRouteKey();
    const { loading, error, movie } = this.state;

    if (loading) return <div style={{padding:16}}>Loading… ({movieKey})</div>;
    if (error) return <pre style={{padding:16,color:'crimson'}}>Error: {error.message}</pre>;
    if (!movie) return <div style={{padding:16}}>No movie data for {movieKey}</div>;

    const { title = { eng: '', fin: '' }, year, runtime, synopsis = '' } = movie;
    const titleMain = title[this.props.lang];
		const titleAlt = this.props.lang === 'eng' ? title['fin'] : title['eng'];

		const people = movie.people || { cast: [], crew: [] };

    return (
      <div className={classes['movie']}>
        <div className={`${classes['movie-content']} mid-cont flex-container dir-col`}>
          <div className={`${classes['content-top']} flex-container dir-row flex-wrap`}>
            {this.state.image?.full &&
              <div className={classes['img-wrapper']}>
                <div
                  className={classes['img']}
                  style={{ backgroundImage: `url(/data/images/${this.state.image.full})` }}></div>
              </div>
            }
            <div className={`${classes['movie-info']} flex-item flex-container dir-col nowrap`}>
              <h1 className="wrap">{titleMain}</h1>
              <h2 className="wrap">{titleAlt}</h2>
              <div className="pad-2-v flex-container dir-col">
                <p>
                  <label>TYPE</label>
                  <span>{this.state.category}</span>
                </p>
                {year &&
                  <p>
                    <label>YEAR</label>
                    <span>{year}</span>
                  </p>
                }
                {runtime &&
                  <p>
                    <label>RUNTIME</label>
                    <span>{runtime}</span>
                  </p>
                }
              </div>
            </div>
          </div>
          <div className={`${classes['content-synopsis']} flex-container dir-row flex-wrap`}>
            <p dangerouslySetInnerHTML={{ __html: synopsis.replace(/(?:\r\n|\r|\n)/g, '<br />') }} />
          </div>
          <div className={`${classes['content-people']} flex-container dir-row flex-wrap`}>
            <div className="flex-container flex-item dir-col">
              <h1>Cast</h1>
              {(people.cast || []).map((person, index) => {
                return (
                  <p key={index}>
                    <span>{person.name}</span>
                  </p>
                );
              })}
            </div>
            <div className="flex-container flex-item dir-col">
              <h1>Crew</h1>
              {(people.crew || []).map((person, index) => {
                return (
                  <p key={index}>
                    <span>{person.name}</span>
                    <span className={classes['job']}>{person.job}</span>
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Movie);
